import { MenuButton } from "./menu-button";
import { MenuContent } from "./menu-content";
import { MenuItem } from "./menu-item";
import { MenuRoot } from "./menu-root";

export const Menu = {
  Root: MenuRoot,
  Item: MenuItem,
  Button: MenuButton,
  Content: MenuContent,
};

export default Menu;
